import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { HeaderService } from "@rubbl-layout";
import { SearchResultsService } from "@rubbl-search-results";
import { AzureSearchResult } from "@rubbl-azure-search";
import { InventoryItem } from "@rubbl-inventory";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-search-results-layout",
  templateUrl: "./search-results-layout.component.html",
  styleUrls: ["./search-results-layout.component.scss"],
})
export class SearchResultsLayoutComponent implements OnInit, OnDestroy {
  searchView: "map" | "grid";
  searchResultsSubscription: Subscription;
  cityStateText: string;
  primaryType: string;
  make: string;
  cityStateForSearch: string;

  constructor(private headerService: HeaderService, private searchResultsService: SearchResultsService, private route: ActivatedRoute) {}

  ngOnInit() {
    this.headerService.showSearchResultsHeaderItems();

    this.searchResultsSubscription = this.searchResultsService.searchResults$.subscribe((results: AzureSearchResult<InventoryItem>) => {
      let hasCityStateInRoute = this.route.snapshot.firstChild.firstChild.paramMap.get("cityState") != null;

      this.cityStateText = hasCityStateInRoute ? `in ${this.searchResultsService.searchRequest.location.toCityState()}` : "Near Me";
      this.cityStateForSearch = this.searchResultsService.searchRequest.location.toCityStateSeo();

      let primaryType = this.route.firstChild.firstChild.snapshot.paramMap.get("primaryType") || "all";
      primaryType = primaryType.replace(/-/g, " ");

      this.make = this.route.firstChild.firstChild.snapshot.paramMap.get("make");
      this.primaryType = primaryType;
    });
  }

  ngOnDestroy(): void {
    this.searchResultsSubscription?.unsubscribe();
  }
}
